<script>

    import { replace } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'
    import Modal from '../$components/modal.container.svelte'

    import ChargesDownload from '../charges/component.charges.download.svelte'
    import ChargesComponent from '../charges/component.charges.svelte'
    import ChargeCreateComponent from '../charges/component.create.svelte'
    import ChargeComponent from '../charges/component.charge.svelte'
    import ChargeUpdateComponent from '../charges/component.update.svelte'

    if(!isPermission($adminStore, 'UsersView.Charges.View'))
        replace('/404')

</script>

<View>
    <PageHeader title="Reembolsos" subtitle="Reembolsos y devoluciones a usuarios" />
    <ChargesComponent all={true} type="refund" />
</View>

<Modal id="charges_download_modal" title="Descargar reembolsos">
    <ChargesDownload />
</Modal>

<Modal id="charge_create_modal" title="Crear reembolso">
    <ChargeCreateComponent />
</Modal>

<Modal id="charge_modal" title="Reembolso">
    <ChargeComponent />
</Modal>

<Modal id="charge_update_modal" title="Actualizar reembolso">
    <ChargeUpdateComponent />
</Modal>
